/**
 * @generated SignedSource<<544f6bacc82c1e593d6465390892752d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AdminApproveAccountInput = {
  userId: string;
};
export type ApprovalsPageApproveMutation$variables = {
  input: AdminApproveAccountInput;
};
export type ApprovalsPageApproveMutation$data = {
  readonly AdminApproveAccount: {
    readonly error: string | null;
    readonly success: boolean;
  };
};
export type ApprovalsPageApproveMutation = {
  response: ApprovalsPageApproveMutation$data;
  variables: ApprovalsPageApproveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminApproveAccountPayload",
    "kind": "LinkedField",
    "name": "AdminApproveAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApprovalsPageApproveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalsPageApproveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "03699fc36a67d7d9717c972d5c94226f",
    "id": null,
    "metadata": {},
    "name": "ApprovalsPageApproveMutation",
    "operationKind": "mutation",
    "text": "mutation ApprovalsPageApproveMutation(\n  $input: AdminApproveAccountInput!\n) {\n  AdminApproveAccount(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "54afa975660fa241cc9a53493aadf8ca";

export default node;
